import type { PropsWithChildren } from 'react';
import { X, AlertCircle } from 'lucide-react';
import { useUIStore } from '@/stores/uiStore';
import { MobileNavigation } from '@/components/MobileNavigation';

export function MailLayout({ children }: PropsWithChildren) {
  const globalError = useUIStore((state) => state.globalError);
  const setGlobalError = useUIStore((state) => state.setGlobalError);

  return (
    <div className="relative flex h-dvh flex-col overflow-hidden app-gradient pwa-safe-area">
      {/* Mobile chrome: paint the top band plum so it reads as one band with the
          dark page headers below it (round 4.2). Scoped to the band — a dark
          root ground would turn bare error/empty states dark-on-dark. `fixed`
          (not absolute) so iOS 26's chrome-tint sampler — which reads fixed
          elements at the viewport edge, else the body — picks up plum here
          too. `--top-band` (index.css) is the status-bar inset widened to
          clear iOS 26's glass effect in a home-screen app. */}
      <div
        aria-hidden
        className="fixed inset-x-0 top-0 z-10 bg-sidebar md:hidden"
        style={{ height: 'var(--top-band)' }}
      />
      {globalError && (
        <div className="mt-3 w-[95vw] max-w-2xl mx-auto glass-surface !border !border-destructive/40 px-4 py-3 text-sm text-destructive animate-fade-in-up rounded-lg !bg-destructive/10">
          <div className="flex items-start gap-3">
            <AlertCircle className="size-4 mt-0.5 flex-shrink-0" />
            <div className="flex-1 min-w-0">
              {globalError}
            </div>
            <button
              onClick={() => setGlobalError(null)}
              className="flex-shrink-0 hover:bg-destructive/20 rounded-full p-0.5 transition-colors"
              aria-label="Dismiss error"
            >
              <X className="size-4" />
            </button>
          </div>
        </div>
      )}

      <div className="flex flex-col flex-1 min-h-0">
        {children}
      </div>
      <MobileNavigation />
    </div>
  );
}
